class Listeners {

  static onIdle(){
    console.log("Idle");
  }

  static onAwake(){
    console.log("Awake");
  }

  static onRefresh(){
    console.log("Refresh");
  }

}

export default Listeners;